import noxios from '../utils/noxios'

type NotificationRequest = {
  partitionKey: string
  params: {
    size: number
    searchType: 'BEFORE' | 'AFTER'
    sortKey?: number
  }
}

export type NotificationsResponse = {
  result: {
    createDateTime: string
    sortKey: number
    data: {
      cta: {
        data: {
          link: string
        }
      }[]
      payload: {
        message: string
      }
    }
  }[]
}

export const notificationApi = {
  getNotifications: ({ partitionKey, params }: NotificationRequest) => {
    return noxios.get<NotificationsResponse>(`/${partitionKey}`, {
      params,
    })
  },
}
